/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminNoticeDto } from '../../models/admin-notice-dto';

export interface AdminNoticeControllerFindById$Params {
  id: string;
}

export function adminNoticeControllerFindById(http: HttpClient, rootUrl: string, params: AdminNoticeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminNoticeDto>> {
  const rb = new RequestBuilder(rootUrl, adminNoticeControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminNoticeDto>;
    })
  );
}

adminNoticeControllerFindById.PATH = '/api/admin-notice/{id}';
